import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, Pagination } from 'common/components/layout';
import {
  concatUrlString,
  pageFromQuery,
  urlPushQuery,
  queryStringFromProps
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import { listOrders, resetOrderQuery } from 'redux/orders/actions';

import OrderList from './components/OrderList';

class OrderHistoryList extends Component {
  componentDidMount() {
    const { props } = this;
    props.resetOrderQuery();
    const urlString = queryStringFromProps(props);
    props.listOrders(urlString);
  }

  search = (page) => {
    const { props } = this;
    props.resetOrderQuery();
    const urlString = concatUrlString(page);
    props.listOrders(urlString);
    props.history.push(urlPushQuery('/profile/order-history', urlString));
  };

  render() {
    const { orders, location, settings } = this.props;
    const page = pageFromQuery(location.search);

    if (!settings.data || !orders.data || orders.query === null) {
      return (
        <Layout title="Order History" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }

    return (
      <Layout title="Order History">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__order-history">
          <h2>Order History</h2>
          <OrderList
            query={orders.query}
            orders={orders.data}
            settings={settings}
          />
          <Pagination
            totalRecords={orders.recordCount}
            page={page || 1}
            search={this.search}
          />
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.order,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listOrders,
  resetOrderQuery
})(OrderHistoryList);
